import { render, staticRenderFns } from "./contract-update.vue?vue&type=template&id=25313246&"
import script from "./contract-update.vue?vue&type=script&lang=js&"
export * from "./contract-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports